import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
// import CurrentCurveChart from './CurrentCurveChart';
import { Inverter1ChartApi } from '../../../../../../api/Api';
import AppModal from "../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../components/inverter/InvverterFullSize";
import DownloadJpegButton from '../../../../../../components/downloadJpegButton/DownloadJpegButton';
import CurrentCurveChart from '../../../inverter1/tabs/tab1Inverter1/tab1Inverter1Chart/CurrentCurveChart';
import SensorSwitchyardTabs from '../SensorSwitchyardTabs';
// import CurrentCurveChart from '../../../inverter1/tabs/tab1Inverter1/tab1Inverter1Chart/CurrentCurveChart';


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0]; // Format: YYYY-MM-DD
    const tenDaysAgo = new Date(date);
    tenDaysAgo.setDate(tenDaysAgo.getDate() - 0);
    const formattedTenDaysAgo = tenDaysAgo.toISOString().split("T")[0]; // Format: YYYY-MM-DD


    return {
        Today: formattedCurrentDate,
        LastDay: formattedTenDaysAgo,
    };
}

function SensorSwitchyardChart({ ID, TabTitle }) {
    const chartRef = useRef();

    const { palette, spacing, shape: { borderRadius } } = useTheme()

    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const [OpenMix, setOpenMix] = useState(false);
    const handleOpenMix = () => setOpenMix(true);
    const handleCloseMix = () => setOpenMix(false);



    // Fetch data dynamically based on updated StartDate, EndDate, and ID
    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        // Generate credentials dynamically using current values
        const credentials = {
            LOGIN_ID: localStorage.getItem("LoginID") || "",
            PASS_KEY: localStorage.getItem("PASS_KEY") || "xyz",
            WEB_KEY: "WEBXYZ321",
            DT1: StartDate,
            DT2: EndDate,
            MTRNO: ID, // Use the latest ID here
        };

        // console.log("Fetching data with credentials:", credentials);

        try {
            const res = await Inverter1ChartApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
            } else {
                setLogData([]);
            }
        } catch (err) {
            // console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    // Re-fetch data whenever StartDate, EndDate, or ID changes
    useEffect(() => {
        fetchLogData();
    }, [ID]); // Add `ID` as a dependency

    // Handle Start Date change
    const handleStartDateChange = (value) => {
        setStartDate(value); // Update the StartDate directly
    };

    // Handle End Date change
    const handleEndDateChange = (value) => {
        setEndDate(value); // Update the EndDate directly
    };



    const chartDataVoltage = {
        labels: logData.map(item => item.DT),
        datasets: [
            {
                label: 'Voltage_R',
                data: logData.map(item => parseFloat(item.Voltage_R) || 0),
                borderColor: 'red',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
            {
                label: 'Voltage_Y',
                data: logData.map(item => parseFloat(item.Voltage_Y) || 0),
                borderColor: 'yellow',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
            {
                label: 'Voltage_B',
                data: logData.map(item => parseFloat(item.Voltage_B) || 0),
                borderColor: 'blue',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
        ],
    };


    const chartDataCurrent = {
        labels: logData.map(item => item.DT),
        datasets: [
            {
                label: 'I_R',
                data: logData.map(item => parseFloat(item.I_R) || 0),
                borderColor: 'red',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
            {
                label: 'I_Y',
                data: logData.map(item => parseFloat(item.I_Y) || 0),
                borderColor: 'yellow',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
            {
                label: 'I_B',
                data: logData.map(item => parseFloat(item.I_B) || 0),
                borderColor: 'blue',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            },
        ],
    };


    const chartDataPower = {
        labels: logData.map(item => item.DT),
        datasets: [
            {
                label: 'Active Power[KW]',
                data: logData.map(item => parseFloat(item.KW) || 0),
                borderColor: 'rgb(255, 153, 51)',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            }
        ],
    };


    const chartDataFrequency = {
        labels: logData.map(item => item.DT),
        datasets: [
            {
                label: 'HZ',
                data: logData.map(item => parseFloat(item.HZ) || 0),
                borderColor: 'red',
                tension: 0.3,
                fill: false,
                borderWidth: 2,
                pointRadius: 1, // Larger point size for better visibility
                pointHoverRadius: 2, // Easier to hover over
            }
        ],
    };


    // Refresh data only when clicking "Show"
    function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }


    return (
        <>
            <CssBaseline />
            <Box ref={chartRef} bgcolor={'background.default'} py={spacing(1)}>

                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 1 }}>
                    <Grid key="chart-grid" item xs={12}>
                        <Card>
                            <CardActions sx={{
                                display: "flex", // Enable flexbox
                                justifyContent: "space-between", // Align items to the right
                                alignItems: "center", // Center items vertically
                                gap: "16px", // Add some spacing between the inputs
                            }}>
                                <div style={{ marginLeft: "7px", fontSize: "14px" }}>Chart ({TabTitle})</div>
                                <div> <label>
                                    From:&nbsp;
                                    <input
                                        type="date"
                                        value={StartDate} // Use StartDate directly
                                        onChange={(e) => handleStartDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />
                                </label>
                                <label>
                                    To:&nbsp;
                                    <input
                                        type="date"
                                        value={EndDate} // Use EndDate directly
                                        onChange={(e) => handleEndDateChange(e.target.value)}
                                        style={{
                                            padding: "2px 2px",
                                            borderRadius: "14px",
                                            border: "1px solid #ccc",
                                        }}
                                    />&nbsp;
                                   
                                     <Button onClick={onRefreshData} variant='contained' sx={{ color: 'white', p: 0, m: 0, fontSize: '12px', backgroundColor: palette.tintBlue, borderRadius: borderRadius }}>Show</Button>
                                     &nbsp; <DownloadJpegButton targetRef={chartRef} fileName={`Chart_${TabTitle}.jpeg`} />
                                </label></div>
                               

                               
                            </CardActions>
                        </Card>
                    </Grid>


                </Grid>

                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 2 }}>
                    <Grid key="chart-grid" item xs={6}>
                        <Card>
                            <CardActions>
                                {/* Pass the 'data' prop correctly */}
                                <CurrentCurveChart data={chartDataVoltage} name={"Voltage Curve"} />


                            

                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid key="chart-grid" item xs={6}>
                        <Card>
                            <CardActions>

                                <CurrentCurveChart data={chartDataCurrent} name={"Current Curve"} />
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>



                <Grid container spacing={spacing(1)} flexGrow={1} sx={{ mt: 3 }}>
                    <Grid key="chart-grid" item xs={6}>
                        <Card>
                            <CardActions>
                                {/* Pass the 'data' prop correctly */}
                                <CurrentCurveChart data={chartDataPower} name={"Power Curve"} />
                            </CardActions>
                        </Card>
                    </Grid>

                    <Grid key="chart-grid" item xs={6}>
                        <Card>
                            <CardActions>

                                <CurrentCurveChart data={chartDataFrequency} name={"Frequency Curve"} />
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default SensorSwitchyardChart;
